import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { UtilityService } from 'lib/ng2-sapmp/src/providers/utility.service';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb/breadcrumb.service';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid-extended/shared/model/grid-options.model';
import { deviceInventory } from 'config';
import { GroupingDevicesService } from '../grouping-devices.service';

@Component({
  selector: 'app-review-group',
  templateUrl: './review-group.component.html',
  styleUrls: ['./review-group.component.scss']
})
export class ReviewGroupComponent implements OnInit {
  showErrors: boolean;
  reviewData: any;
  rowData: any = [];
  gridOptions: GridOptionsModel;
  customGridOptions = new GridOptionsModel();
  reviewDataCol: any = deviceInventory.reviewGroupDevices;
  showTable: boolean = false;
  getSelectedGroupFan: any;
  groupName: any;

  totalDevices: number;
  data: { fan: string; newGroupName: any; groupDetails: any[]; };
  selectedFan: string;
  existingGroupArr: any = [];
  formSuccess: boolean;
  failuremessage: boolean;


  constructor(private stepIndicatorService: StepIndicatorService,
    private route: ActivatedRoute,
    private chips: ChipsService,
    private pageloaderService: PageLoaderService,
    private utilityService: UtilityService,
    private router: Router,
    private breadCrumbService: BreadCrumbService,
    private groupDevicesService: GroupingDevicesService
    ) { }

  ngOnInit(): void {
    this.pageloaderService.setPageLoaderStatus(true);
    this.selectedFan = sessionStorage.getItem("selectedFAN");
    this.breadCrumbService.removeLastBreadCrumb();
    this.chips.setChips([{
			"label": "Home",
			"routerLink": "/home"
		}, {
			"label": "Manage Accounts",
			"routerLink": "/manageInventory"
		}, {
			"label": 'Devices for foundation account   ' + this.selectedFan,
			"routerLink": "manageInventory/deviceInventory"
		},
				 {
			"label": "Group Devices",
			"routerLink": "/groupingDevices/review"
		}]);
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    this.rowData = JSON.parse(sessionStorage.getItem("selectedDevicesForGrouping"));
    this.groupName = sessionStorage.getItem("groupSelection");
    this.totalDevices= Object.keys(this.rowData).length
    this.initGrid();
  }

  initGrid(){
    
    this.customGridOptions.enableFiltering = false;
      this.customGridOptions.enableSorting = false;
      this.customGridOptions.multiSelect = false;
      const pagination = {
        recordsPerPage: 15,
        currentPage: 1,
        isServerSide: false,
        totalRecords: this.totalDevices,
        hideGoToPage: true
      };
      this.customGridOptions.enableBackLink = true;
      this.customGridOptions.backLinkText = "Back";
      this.customGridOptions.emptyMessage = "Table is empty";
      this.customGridOptions.searchPlaceHolder = "";
      this.customGridOptions.ariaLabel = "";
      this.customGridOptions.Paginations = pagination;
      this.customGridOptions.gridData = this.rowData;
      this.customGridOptions.columnDefinitions = this.reviewDataCol.columnDefinitions;
      this.customGridOptions.searchDescriptions = '';
      this.customGridOptions.ctnMask = false;
      this.customGridOptions.imeiMask = false;
      this.customGridOptions.maxLength = 15;
      this.customGridOptions.disableGrid = false;
      this.customGridOptions.disableRow = false;
      this.customGridOptions.disableRowCondition = { field: '', value: '' };
         // refine grid data for "Claimed_Android"
      this.customGridOptions.gridData.map(function(x){
      if(x.status == "Claimed_Android"){
          x.status = "Claimed_Android™"
        }
      })
      this.customGridOptions.callbacks = {
        callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
        callBackProfileStatus: this.callBackProfileStatus,
        callBackImei: this.callBackImei
      }
      
      this.gridOptions = this.customGridOptions;
      this.pageloaderService.setPageLoaderStatus(true);
      return this.gridOptions;
    
  }
  dismissInfo() {
    this.showErrors = false;
  }
  clickShowTable(){
    this.showTable = true;
  }
  clickHideTable(){
    this.showTable = false;
  }

  clickBack(){
    this.stepIndicatorService.setCurrentStep("selectGroup");
    this.stepIndicatorService.setVisibility(true);
    this.pageloaderService.setPageLoaderStatus(false);
    this.router.navigate(['/groupingDevices/selectGroup']);
  }

  clickCancel(){
    this.pageloaderService.setPageLoaderStatus(false);
    this.router.navigate(['manageInventory/deviceInventory']);
  }

  clickChange(){
    this.pageloaderService.setPageLoaderStatus(false);
    this.router.navigate(['groupingDevices/selectDevices']);
    sessionStorage.setItem('callingURL', '/groupingDevices/review');
  }

  submitGroup(){
    this.pageloaderService.setPageLoaderStatus(false);
    this.rowData.forEach(data => {
      var obj : any = {}
      obj.imei = data.imei;
      obj.groupname = data.group;
      this.existingGroupArr.push(obj);
    });

    this.data = {
      "fan": this.selectedFan,
      "newGroupName" : this.groupName,
      "groupDetails" : this.existingGroupArr
      }
    this.groupDevicesService.submitGroupData(this.data).subscribe(responseObject => {
        if(responseObject.status === 'success'){
        sessionStorage.setItem("reviewGrpSuccess", "true");
        sessionStorage.removeItem('groupSelection');
        sessionStorage.removeItem('createGroupFlag');
        this.router.navigate(['manageInventory/deviceInventory']);
      }else {
        sessionStorage.setItem("reviewGrpSuccess", "false");
      }
    }, (error: any) => {
      console.log("Error for grouping devices: "+ error);
      this.showErrors = true;
      this.pageloaderService.setPageLoaderStatus(true);
    });
  }

  /*add two cell for status updated in grid column */
  callBackProfileStatus(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, '-').toLowerCase();
    let status = row.status.replace(/_/g, ' ');
    if (status === 'ENROLLED ACTIVE') {
      status = 'Enrolled, active';
    }else if (status === 'OUT OF COMPLIANCE') {
      status = 'Not compliant';
    }else if (status === 'ENROLLED NOT ACTIVE') {
      status = 'Enrolled, not active';
    }else if (status === 'NOT ENROLLED') {
      status = 'Not enrolled';
    }else if (status === 'Claimed Android™') {
      status = 'claimed (Android™)';
    }else if (status === 'Claimed Android') {
      status = 'claimed (Android™)';
    }else if (status === 'Claimed Samsung') {
      status = 'claimed (Samsung)';
    }else if (status === 'Claimed Apple') {
      status = 'claimed (Apple)';
    }else if (status === 'UNCLAIM PENDING Android™') {
      status = 'unclaim pending (Android™)';
    }else if (status === 'UNCLAIM PENDING Android') {
      status = 'unclaim pending (Android™)';
    }else if (status === 'UNCLAIM PENDING Samsung') {
      status = 'unclaim pending (Samsung)';
    }else if (status === 'UNCLAIM PENDING Apple') {
      status = 'unclaim pending (Apple)';
    }else if (status === 'CLAIM PENDING Android™') {
      status = 'claim pending (Android™)';
    }else if (status === 'CLAIM PENDING Android') {
      status = 'claim pending (Android™)';
    }else if (status === 'CLAIM PENDING Samsung') {
      status = 'claim pending (Samsung)';
    }else if (status === 'CLAIM PENDING Apple') {
      status = 'claim pending (Apple)';
    }else if (status === 'Not Claimed') {
      status = 'not claimed';
    }else if (status === 'UNCLAIM PENDING') {
      status = 'unclaim pending';
    }else if (status === 'CLAIM PENDING') {
      status = 'claim pending';
    }
    // return `<span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span>`;
    return `<div class="gridText" > <span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span> </div>`;

  }

  callBackImei(element, row, field, currentElem, type, col) {
    let imei = row.imei;
    let imei2 = row.complianceStatus
    if(imei2 == "Unknown" || imei2 === undefined || imei2 === "" || imei2 === null) {
      return `<span class="imei1">${imei}</span>`;
    }else{
      return `<span class="imei1">${imei}</span><p class="imei2">${imei2}</p>`;
    }
  }

   /*add two cell for link of CTN and username */
   callBackAppNameCellTemplate(element, row, field, currentElem, type, col) {
    if (type === 'template') { 
      if(row.ctnNumber == null || row.ctnNumber == "" || row.ctnNumber == "Unknown") {
        const formatctnNumber = "Unknown";
        return ` <span class='ctn-number'>${formatctnNumber}</span>`;
      } else {
        const formatctnNumber = row.ctnNumber.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
        return ` <span class='ctn-number'>${formatctnNumber}</span>`;
      }
    } else if (type.target.classList.contains('ctn-number')) {
      currentElem.onDataChange.emit({ data: row, type: 'ctnInfo' });
    }
  }

}
